import type { ServerConfig } from "@attensi/frontend-server"

const config = {
  env: [
    "VITE_ADMIN_URL",
    "VITE_API_TOKEN",
    "VITE_APP_ENV",
    "VITE_AUTH_URL",
    "VITE_BACKOFFICE_API_URL",
    "VITE_LEADERBOARD_API_URL",
    "VITE_LOGIN_URL",
  ],

  optionalEnv: ["GIT_COMMIT_SHA", "VITE_OPTIMIZER_URL"],

  envPrefix: "VITE_",

  publicRoot: "./dist",

  isImmutableFile: ({ dir }) => dir.endsWith("assets"),

  contentSecurityPolicy: {
    imgSrc: ["https:", "wss:"],
    scriptSrc: ["*.attensi.com"],
    workerSrc: ["blob:"],
    connectSrc: [
      "*.attensi.com",
      "*.sentry.io",
      "localhost:*",
      "wss://*.attensi.com",
    ],
    frameSrc: "*",
    reportUri: "https://attensi.report-uri.com/r/t/csp/reportOnly",
    reportOnly: true,
  },

  // TODO
  // This allows embedding entire ENGAGE in an iframe and is a temporary solution!
  // Only specific routes should be allowed to be embeddable, but it requires changes in frontend-server
  helmetConfig: {
    xFrameOptions: false,
  },
} as const satisfies ServerConfig

export default config
